import { UseLivePriceKey } from './useLivePrice.types';
import {
  UseLivePriceOnMessage,
  useLivePriceReceiver,
} from './useLivePriceReceiver';
import { useLivePriceSender } from './useLivePriceSender';
import { LivePriceSymbolsKeyEnum } from './liveprice.store.types';

export const useLivePrice = (
  symbols: string[],
  stateKey: LivePriceSymbolsKeyEnum,
  actionKey: UseLivePriceKey,
  onMessage: UseLivePriceOnMessage,
) => {
  useLivePriceSender(stateKey, symbols);
  useLivePriceReceiver(symbols, actionKey, onMessage);
};
